import React, { useEffect, useState } from "react";
import { Button, Card, CardHeader, CardBody, CardTitle, Row, Col, Table, Modal, ModalHeader, ModalBody, Input } from "reactstrap";
import useToken from "../../../helpers/useToken"
import TMHLoader from "../../TMHLoader/TMHLoader"
import { parseCustomTime } from "../../../helpers/utils";
import useTimeZone from "../../../helpers/useTimeZone"
import PaginationCustom from "../../PaginationCustom/PaginationCustom"

export default function ProcessedCodeTable({ platforms }) {
    const [users, setUsers] = useState()
    const { token } = useToken()
    const { timeZone } = useTimeZone()
    const [isLoading, setIsLoading] = useState(false)
    const [isOpenEditCodeModal, setIsOpenEditCodeModal] = useState(false)
    const [pager, setPager] = useState({
        size: 10,
        offset: 0,
        platformId: -1
    });

    const [total, setTotal] = useState(0)

    useEffect(() => {
        const initData = async () => {

            console.log('AvailableCodeTable: update data')
            setIsLoading(true)
            var myHeaders = new Headers();
            myHeaders.append("Cache-Control", "no-cache");
            myHeaders.append("Access-Token", token);

            var requestOptions = {
                method: 'GET',
                headers: myHeaders,
            }

            var params = new URLSearchParams({
                'page_size': pager.size,
                'offset': pager.offset,
                'partner_id': pager.platformId
            })

            fetch(process.env.REACT_APP_BASE_URL + "rewards/processed_users?" + params, requestOptions)
                .then((response) => {
                    return new Promise((resolve) => response.json()
                        .then((json) => resolve({
                            status: response.status,
                            ok: response.ok,
                            json,
                        })))
                }).then(
                    (result) => {
                        var json = result.json
                        if (result.ok) {
                            setUsers(json.data)
                            setTotal(json.page_dto.total)
                            setIsLoading(false)
                        }
                        else {
                            console.log(result.json)
                            setIsLoading(false)
                        }
                    }
                )
        }

        initData()
    }, [pager, token])

    return (
        <TMHLoader active={isLoading}>
            <Modal color="dark" isOpen={isOpenEditCodeModal}>
                <ModalHeader tag="h2">Edit Reward Code</ModalHeader>
                <ModalBody>
                    <Row>
                        <Col md="4">
                            Platform Partner:
                        </Col>
                        <Col>
                            <Input className="text-dark" type="select">
                                {platforms?.map((data) => {
                                                return (<option value={data.id} key={data.id}>{data.name}</option>)
                                            })}
                            </Input>
                        </Col>
                    </Row>
                    <Row className="my-4">
                        <Col md="4">
                            Code:
                        </Col>
                        <Col>
                            <Input className="text-dark" type="text" />
                        </Col>

                    </Row>
                    <Row className="text-center">
                        <Col md="6">
                            <Button color="success">Add</Button>
                        </Col>
                        <Col md="6">
                            <Button onClick={() => setIsOpenEditCodeModal(false)} color="danger">Cancel</Button>
                        </Col>
                    </Row>
                </ModalBody>
            </Modal>

            <Row>
                <Col md="12">
                    <Card>
                        <CardHeader>
                            <CardTitle tag="h2">Claimed ({total})</CardTitle>
                            <CardTitle>
                                <Row>
                                    <Col className="pr-md-1" md="3">
                                        Show {" "}
                                        <select onChange={(e) => setPager({ ...pager, size: e.target.value, offset: 0 })}>
                                            <option>10</option>
                                            <option>25</option>
                                            <option>50</option>
                                            <option>100</option>
                                        </select> entries {" "}
                                    </Col>
                                    <Col className="pl-md-1" md="3">
                                        Partner: {" "}
                                        <select onChange={(e) => setPager({ ...pager, platformId: e.target.value, offset: 0 })}>
                                        <option value={-1}>All</option>
                                            {platforms?.map((data) => {
                                                return (<option value={data.id} key={data.id}>{data.name}</option>)
                                            })}
                                        </select>
                                    </Col>
                                </Row>
                            </CardTitle>
                        </CardHeader>
                        <CardBody>
                            <Table striped className="tablesorter">
                                <thead className="text-primary">
                                    <tr>
                                        <th>Partner Name </th>
                                        <th>Code</th>
                                        <th>User Name</th>
                                        <th>Email</th>
                                        <th>Pin</th>
                                        <th>Device Id</th>
                                        <th>Signup Method</th>
                                        <th>Claim Date</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {users?.map((data) => {
                                        return (
                                            <tr key={data.id}>
                                                <td>{platforms?.find(platform => platform.id === data.partner_id)?.name}</td>
                                                <td>{data.code}</td>
                                                <td>{data.first_name} {data.last_name}</td>
                                                <td>{data.email}</td>
                                                <td>{data.pin}</td>
                                                <td>{data.device_id?.split('-')[0]}</td>
                                                <td>{data.signup_method}</td>
                                                <td>{parseCustomTime(data.claim_date, timeZone)}</td>
                                            </tr>
                                        )
                                    })}
                                </tbody>
                            </Table>

                            <PaginationCustom pager={pager} setPager={setPager} total={total} />
                        </CardBody>
                    </Card>

                </Col>
            </Row>
        </TMHLoader>
    )
}